import React from "react";
import { XGShot, getHomeColor, getAwayColor } from "../utils";
import { InfoCard } from "sports/Football/components/InfoCard";

export const ShotCard: React.FC<{ shot: XGShot; status: any }> = ({
  shot,
  status,
}) => {
  const headerBg =
    shot.team === "home" ? getHomeColor(status) : getAwayColor(status);

  return (
    <InfoCard
      title={shot.player || "Player"}
      titleRight={(shot.xg ?? 0).toFixed(3)}
      headerBg={headerBg}
      rows={[
        { label: "Outcome", value: shot.outcome || "-" },
        {
          label: "Time",
          value: `${
            shot.minute != null ? String(shot.minute).padStart(2, "0") : "--"
          }:${shot.sec != null ? String(shot.sec).padStart(2, "0") : "00"}`,
        },
        { label: "Hit Type", value: shot.foot || "-" },
      ]}
    />
  );
};
